export const translate = {
    "기본 정보": {
        ko: "기본 정보",
        en: "Basic information",
    },

    "방문 일자": {
        ko: "방문 일자",
        en: "Date of visit",
    },

    "방문 시간": {
        ko: "방문 시간",
        en: "Time of visit",
    },

    "방문 목적": {
        ko: "방문 목적",
        en: "Purpose of visit",
    },

    "방문자 소속": {
        ko: "방문자 소속",
        en: "Department of visitor",
    },

    선택: {
        ko: "선택",
        en: "Optional",
    },

    "방문자 안내 언어": {
        ko: "방문자 안내 언어",
        en: "Visitor's Guide Language",
    },

    "방문 담당자": {
        ko: "방문 담당자",
        en: "Host of visit",
    },

    "방문 담당자 설명": {
        ko: "방문 담당자 모두에게 방문 일정이 생성되며, 태블릿에서 담당자 호출 시 모두에게 알림 메시지가 전송됩니다.",
        en: "All host receive a visit schedule, and when the host is called on the tablet, an message is sent to all.",
    },

    "담당자 검색": {
        ko: "담당자 검색",
        en: "Search Manager",
    },

    "이미 추가된 담당자입니다.": {
        ko: "이미 추가된 담당자입니다.",
        en: "Managers already added.",
    },


    한국어: {
        ko: "한국어",
        en: "Korean",
    },

    영어: {
        ko: "영어",
        en: "English",
    },

    "방문자 정보": {
        ko: "방문자 정보",
        en: "Visitors Information",
    },

    "개별 방문 활성화": {
        ko: "개별 방문 활성화",
        en: "Activate individual visit",
    },
    
    "개별 방문 활성화 설명": {
        ko: "* 옵션을 활성화 시키면, 방문자에게 개별 입장이 가능한 QR 코드가 제공됩니다. (ex. 면접, 세미나)",
        en: "When the option is activated, visitors will be provided with individual entry QR codes. (e.g., for interviews, seminars).",
    },

    이름: {
        ko: "이름",
        en: "Name",
    },

    "안내 채널": {
        ko: "안내 채널",
        en: "Guide channel",
    },

    "전화번호/이메일": {
        ko: "전화번호/이메일",
        en: "Contact",
    },

    "이메일을 입력하세요.": {
        ko: "이메일을 입력하세요.",
        en: "email",
    },

    "전화번호를 입력하세요.": {
        ko: "전화번호를 입력하세요",
        en: "tel",
    },

    "Excel 형식 다운로드": {
        ko: "Excel 형식 다운로드",
        en: "Download Excel",
    },

    "방문자 등록 Excel 업로드": {
        ko: "방문자 등록 Excel 업로드",
        en: "Upload Excel",
    },

    "내용을 입력해주세요.": {
        ko: "내용을 입력해주세요.",
        en: "",
    },

    "방문자 추가하기": {
        ko: "방문자 추가하기",
        en: "Add Visitor",
    },

    등록하기: {
        ko: "등록하기",
        en: "Register",
    },

    저장하기: {
        ko: "저장하기",
        en: "Save",
    },

    "이메일을 입력해주세요.": {
        ko: "이메일을 입력해주세요",
        en: "email",
    },

    "전화번호를 - 없이 입력해주세요.": {
        ko: "전화번호를 - 없이 입력해주세요.",
        en: "Call Number Please enter without '-' .",
    },

    "방문자 정보를 모두 기입해주세요.": {
        ko: "방문자 정보를 모두 기입해주세요.",
        en: "Please fill out all the visitor information.",
    },

    "방문 정보를 모두 기입해주세요.": {
        ko: "방문 정보를 모두 기입해주세요.",
        en: "Please fill out all the visitor information.",
    },

    "사전 방문자 수정이 완료되었습니다.": {
        ko: "사전 방문자 수정이 완료되었습니다.",
        en: "The visitor information modification has been completed.",
    },

    "방문 정보가 등록되었습니다.": {
        ko: "방문 정보가 등록되었습니다.",
        en: "Your visit information has been registered.",
    },

    "해당 시간에 이미 예약된 일정이 있습니다.": {
        ko: "해당 시간에 이미 예약된 일정이 있습니다.",
        en: "You already have a scheduled schedule at that time.",
    },
};
